import { PatientData } from './patients'

export enum TASK_STATUS {
	OPEN = 'Open',
	CLOSED = 'Closed',
}

export enum TASK_STATUS_FOR_EXTERNAL_CLINIC {
	TO_DO = 'To-Do',
	IN_PROGRESS = 'In-progress',
	DONE = 'Done',
}

export enum TASK_STATUS_FOR_INTERNAL_CLINIC {
	TO_DO = 'To-do',
	CHAT_COMPLETE = 'Chat Complete',
	REFER_TO_SUPPORT_COMPLETE = 'Refer to Support Complete',
	REFER_TO_SPECIALTY_COACH_COMPLETE = 'Refer to Specialty Coach Complete',
	REFER_TO_PARTNER_COMPLETE = ' Refer to Partner Complete',
	REFER_TO_EXTERNAL_COMPLETE = ' Refer to External Complete',
	DECLINED_COACHING_COMPLETE = 'Declined Coaching Complete',
	CHECK_IN_COMPLETE = 'Check In Complete',
	LEFT_VOICEMAIL_INCOMPLETE = 'Left Voicemail Incomplete',
	NO_ANSWER_INCOMPLETE = 'No Answer Incomplete',
	BUSY_INCOMPLETE = 'Busy Incomplete',
	CALL_BACK_INCOMPLETE = 'Call Back Incomplete',
	LEFT_MSG_WITH_PERSON_INCOMPLETE = 'Left Message with Person Incomplete',
	HANG_UP_INCOMPLETE = 'Hang Up Incomplete',
	PHONE_DISCONNECTED_INCOMPLETE = 'Phone Disconnected Incomplete',
	CALL_DROPPED_INCOMPLETE = 'Call Dropped Incomplete',
	WRONG_NUMBER_COMPLETE = 'Wrong Number Complete',
	REQUEST_NO_CONTACT_COMPLETE = 'Request No Contact Complete',
	DISENROLLEMENT_REQUESTED_COMPLETE = 'Disenrollment Requested Complete',
	CONTINUE_SPECIALTY_COACHING_COMPLETE = 'Continue Specialty Coaching Complete',
	INELIGIBLE = 'Ineligible',
}

export type TaskStatusUnion =
	| typeof TASK_STATUS[keyof typeof TASK_STATUS]
	| typeof TASK_STATUS_FOR_EXTERNAL_CLINIC[keyof typeof TASK_STATUS_FOR_EXTERNAL_CLINIC]
	| typeof TASK_STATUS_FOR_INTERNAL_CLINIC[keyof typeof TASK_STATUS_FOR_INTERNAL_CLINIC]

export enum TASK_PRIORITIES {
	LOW = 'Low',
	MEDIUM = 'Medium',
	HIGH = 'High',
}

export enum TASK_TYPES {
	FOLLOWUP = 'FOLLOWUP',
	ACTION_ITEM = 'ACTION_ITEM',
	CHECKUP_CALL = 'CHECKUP_CALL',
	SYSTEM = 'SYSTEM',
}

export enum TASK_TYPES_V2 {
	CHAT = 'CHAT',
	INBOUND_CALL = 'INBOUND_CALL',
	OUTBOUND_CALL = 'OUTBOUND_CALL',
	INTERNAL_TASK = 'INTERNAL_TASK',
	PERSONAL = 'PERSONAL',
}

export type TaskTypeUnion =
	| typeof TASK_TYPES[keyof typeof TASK_TYPES]
	| typeof TASK_TYPES_V2[keyof typeof TASK_TYPES_V2]

export enum TASK_WORKFLOW_PROCESSES {
	DEFAULT = 'Default',
	ONBOARDING = 'Onboarding',
	RETENTION = 'Retention',
}

export enum TASK_WORKFLOW_STAGES {
	NEW = 'New',
	WELCOME_CALL = 'Welcome Call',
	FINISHED = 'Finished',
}

export enum TASK_CATEGORIES {
	METABOLIC_GENERAL = 'Metabolic-General',
	BG = 'Blood Glucose',
	BP = 'Blood Pressure',
	WEIGHT = 'Weight',
	MSK = 'Musculoskeletal',
	BH = 'Behavioural Health',
}

export enum TASK_SOURCE {
	MANUAL = 'Manual',
	SYSTEM = 'System',
}

export interface TaskPriorityConfig {
	id: TASK_PRIORITIES
	value: Uppercase<TASK_PRIORITIES>
	default?: boolean
}

export interface TaskWorkflowProcessesConfig {
	id: string
	value: TASK_WORKFLOW_PROCESSES
}

export interface TaskWorkflowStagesConfig {
	id: string
	value: TASK_WORKFLOW_STAGES
}

interface TaskSettings {
	status: TaskStatusUnion
	priority: TASK_PRIORITIES
	reminder: number
	dueDate: string
}
interface TaskOwner {
	_id: string
	personal: {
		name: string
	}
	extra: {
		organizationID: string
	}
}

interface TaskDetails {
	patients: Array<string>
	owner: string
	type?: TaskTypeUnion
	title: string
	description?: string
}

interface TaskWorkFlow {
	process: TASK_WORKFLOW_PROCESSES
	stage: TASK_WORKFLOW_STAGES
}

export type TaskPatientData = PatientData

export interface Task {
	_id: string
	details: TaskDetails
	patientsData?: Array<TaskPatientData>
	settings: TaskSettings
	workflow: TaskWorkFlow
	taskOwner?: TaskOwner
	patient?: string[]
}

export class TaskModel implements Task {
	_id: string
	details: TaskDetails
	patientsData?: Array<TaskPatientData>
	settings: TaskSettings
	workflow: TaskWorkFlow
	taskOwner?: TaskOwner
	constructor() {
		this._id = ''
		this.details = {
			patients: [],
			owner: '',
			type: TASK_TYPES.SYSTEM,
			title: '',
		}
		this.settings = {
			status: TASK_STATUS.OPEN,
			priority: TASK_PRIORITIES.LOW,
			reminder: 0,
			dueDate: '',
		}
		this.workflow = {
			process: TASK_WORKFLOW_PROCESSES.DEFAULT,
			stage: TASK_WORKFLOW_STAGES.NEW,
		}
	}
}

export interface CreateTaskData {
	details: TaskDetails
	settings: TaskSettings
}

export type TasksByDate = Array<Array<string | Array<Task>>>

export interface TasksTableCells {
	id: string
	title: string
	owner: string
	type: string
	due: string
	priority: string
	patient: string
	account: string
	status: string
	edit?: string
}
